<template>
  <div class="gen-entrance">
    <picture>
      <source srcset="../../assets/img/gen/entrance/image01.jpg"
                media="(min-width: 768px)">
      <source srcset="../../assets/img/gen/entrance/image01_sp.jpg"
                media="(max-width: 767px)">
      <img src="../../assets/img/gen/entrance/image01.jpg" />
    </picture>
    <div class="catch">
      <transition name="fade01">
        <div class="item" v-if="show01" >
          <img src="../../assets/img/gen/entrance/catch01.png" />
        </div>
      </transition>
      <transition name="fade02">
        <div class="item" v-if="show02" >
          <img src="../../assets/img/gen/entrance/catch02.png" />
        </div>
      </transition>
      <transition name="fade03">
        <div class="item" v-if="show03" >
          <img src="../../assets/img/gen/entrance/catch03.png" />
        </div>
      </transition>
    </div>
    <nav class="gen-nav">
      <ul>
        <router-link to="/newgraduate/gen/staff">
        <li>
          社員紹介
          <KurehaArrow class="kureha_arrow" :width="50" />
        </li>
        </router-link>
        <router-link to="/newgraduate/gen/work">
        <li>
          クレハの仕事
          <KurehaArrow class="kureha_arrow" :width="50" />
        </li>
        </router-link>
      </ul>
    </nav>
  </div>
</template>

<script>
import KurehaArrow from "@/components/icons/KurehaArrow.vue"
export default {
  name: 'gen_entrance',
  data() {
    return {
      show01: false,
      show02: false,
      show03: false
    }
  },
  components: {
    KurehaArrow,
    // IconBase,
  },
  mounted() {
    setTimeout(()=> {
      this.show01 = true
    }, 200);
    setTimeout(()=> {
      this.show02 = true
    }, 2000);
    setTimeout(()=> {
      this.show03 = true
    }, 3500);
  }
}
</script>
<style lang="scss" scoped>
.gen-entrance {
  position: relative;
}
.catch {
  position: absolute;
  transform: translateY(-50%);
  margin: auto;
  @media print,screen and (min-width: 1201px) {
    top: 30%;
    right: 10%;
    width: 100%;
    max-width: 450px;
    height: 280px;
  }
  @media print,screen and (max-width: 1200px) {
    top: 30%;
    right: 5%;
    width: 100%;
    max-width: 300px;
    height: 200px;
  }
  @media print,screen and (max-width: 767px) {
    top: 20%;
    left: 10%;
    width: 100%;
    max-width: 300px;
    height: 140px;
    right: unset;
  }
  .item {
    position: absolute;
    overflow: hidden;
    width: 100%;
    img {
      max-width: none;
      height: 100%;
      width: 450px;
      @media print,screen and (max-width: 1200px) {
        width: 300px;
      }
      @media print,screen and (max-width: 767px) {
        width: 200px;
      }
      // @media print,screen and (max-width: 767px) {
      //   width: 200px;
      // }
    }
  }
  .item:nth-child(1) {
    top: 0;
  }
  .item:nth-child(2) {
    top: 100px;
    @media print,screen and (max-width: 1200px) {
      top: 70px;
    }
    @media print,screen and (max-width: 767px) {
      top: 50px;
    }
  }
  .item:nth-child(3) {
    bottom: 0;
  }
}
.gen-nav {
  min-width:320px;
  position: absolute;
  bottom: 15%;
  right: 10%;
  @media print,screen and (max-width: 767px) {
    margin: 0 auto;
    right: 0;
    left: 0;
    max-width: 74%;
  }
  li {
    font-size: 22px;
    color: #3fae00;
    background-color: #fff;
    border-radius: 30px;
    margin-top: 20px;
    // padding: 5px 30px;
    padding: 5px 40px 5px 30px;
    font-weight: bold;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    @media print,screen and (max-width: 767px) {
      font-size: 18px;
      letter-spacing: 0em;
      // padding: 5px 16px;
      padding: 5px 20px 5px 16px;
    }
  }
  a {
    display: block;
  }
  .kureha_arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-40%);
    margin: auto;
    right: 10px;
    left: auto;
    bottom: auto;
    @media print,screen and (max-width: 767px) {
      width: 40px;
    }
  }
}
@keyframes open-in {
  0% {
    width: 0%;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
.fade01-enter-active,.fade01-enter-active {
  animation: open-in 1.5s linear;
}
.fade01-enter {
  width: 0%;
}
.fade02-enter-active, .fade02-leave-active {
  animation: open-in 1.5s linear;
}
.fade02-enter {
  width: 0%;
}
.fade03-enter-active, .fade03-leave-active {
  animation: open-in 1.5s;
}
.fade-enter03 {
  width: 0%;
}
.fade03-leave-to {
  width: 100%;
}
</style>
